const headers = {
  consolidated: {
    regular: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine;
        return ((_r$data$object$busine = r.data.object.business_unit) === null || _r$data$object$busine === void 0 ? void 0 : _r$data$object$busine.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine2;
        return ((_r$data$object$busine2 = r.data.object.business_unit) === null || _r$data$object$busine2 === void 0 ? void 0 : _r$data$object$busine2.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_;
        return ((_r$data$object$claim_ = r.data.object.claim_project_report) === null || _r$data$object$claim_ === void 0 ? void 0 : _r$data$object$claim_.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_2;
        return ((_r$data$object$claim_2 = r.data.object.claim_project_report) === null || _r$data$object$claim_2 === void 0 ? void 0 : _r$data$object$claim_2.project_name) || '';
      }
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_3;
        return ((_r$data$object$claim_3 = r.data.object.claim_project_report) === null || _r$data$object$claim_3 === void 0 ? void 0 : _r$data$object$claim_3.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_4;
        return ((_r$data$object$claim_4 = r.data.object.claim_project_report) === null || _r$data$object$claim_4 === void 0 ? void 0 : _r$data$object$claim_4.program_type) || '';
      }
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme;
        return ((_r$data$object$fragme = r.data.object.fragmentable) === null || _r$data$object$fragme === void 0 ? void 0 : _r$data$object$fragme.name) || '';
      }
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total;
        return (_r$data$object$total = r.data.object.total) !== null && _r$data$object$total !== void 0 ? _r$data$object$total : '';
      }
    }, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita;
        return (_r$data$object$capita = r.data.object.capitalised_costs) !== null && _r$data$object$capita !== void 0 ? _r$data$object$capita : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am;
        return (_r$data$object$rnd_am = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am !== void 0 ? _r$data$object$rnd_am : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex;
        return (_r$data$object$pnl_ex = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex !== void 0 ? _r$data$object$pnl_ex : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_;
        return (_r$data$object$s1308_ = r.data.object.s1308_claim) !== null && _r$data$object$s1308_ !== void 0 ? _r$data$object$s1308_ : '';
      }
    }].filter(Boolean),
    realtime: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine3;
        return ((_r$data$object$busine3 = r.data.object.business_unit) === null || _r$data$object$busine3 === void 0 ? void 0 : _r$data$object$busine3.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine4;
        return ((_r$data$object$busine4 = r.data.object.business_unit) === null || _r$data$object$busine4 === void 0 ? void 0 : _r$data$object$busine4.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_5;
        return ((_r$data$object$claim_5 = r.data.object.claim_project_report) === null || _r$data$object$claim_5 === void 0 ? void 0 : _r$data$object$claim_5.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_6;
        return ((_r$data$object$claim_6 = r.data.object.claim_project_report) === null || _r$data$object$claim_6 === void 0 ? void 0 : _r$data$object$claim_6.project_name) || '';
      }
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_7;
        return ((_r$data$object$claim_7 = r.data.object.claim_project_report) === null || _r$data$object$claim_7 === void 0 ? void 0 : _r$data$object$claim_7.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_8;
        return ((_r$data$object$claim_8 = r.data.object.claim_project_report) === null || _r$data$object$claim_8 === void 0 ? void 0 : _r$data$object$claim_8.program_type) || '';
      }
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Period (Month, Qtr, Half)'
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme2;
        return ((_r$data$object$fragme2 = r.data.object.fragmentable) === null || _r$data$object$fragme2 === void 0 ? void 0 : _r$data$object$fragme2.name) || '';
      }
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total2;
        return (_r$data$object$total2 = r.data.object.total) !== null && _r$data$object$total2 !== void 0 ? _r$data$object$total2 : '';
      }
    }, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita2;
        return (_r$data$object$capita2 = r.data.object.capitalised_costs) !== null && _r$data$object$capita2 !== void 0 ? _r$data$object$capita2 : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am2;
        return (_r$data$object$rnd_am2 = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am2 !== void 0 ? _r$data$object$rnd_am2 : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex2;
        return (_r$data$object$pnl_ex2 = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex2 !== void 0 ? _r$data$object$pnl_ex2 : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_2;
        return (_r$data$object$s1308_2 = r.data.object.s1308_claim) !== null && _r$data$object$s1308_2 !== void 0 ? _r$data$object$s1308_2 : '';
      }
    }].filter(Boolean)
  }
};
const buildRows = {
  consolidated: {
    regular: (costFragments, buildCustomCell) => costFragments.map(costFragment => ({
      key: costFragment.id,
      data: {
        object: costFragment
      },
      columns: [buildCustomCell({
        cellType: 'BusinessUnitDropdown',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectSelector',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectTypeDropdown',
        costFragment
      }), buildCustomCell({
        fieldName: 'rate_type',
        costFragment,
        cellType: 'text',
        disabled: true,
        translateValue: true
      }), buildCustomCell({
        fieldName: 'name',
        costFragment,
        cellType: 'text',
        model: 'fragmentable'
      }), buildCustomCell({
        fieldName: 'total',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'capitalised_costs',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'direct_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'indirect_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'consolidated_percentage_of_time_spent',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'eligible_rnd_percentage',
        costFragment,
        cellType: 'percentage',
        disabled: true
      }), buildCustomCell({
        fieldName: 'rnd_amount',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 'pnl_expenditure',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 's1308_claim',
        costFragment,
        cellType: 'number',
        disabled: true
      })]
    })),
    realtime: (costFragments, buildCustomCell) => costFragments.map(costFragment => ({
      key: costFragment.id,
      data: {
        object: costFragment
      },
      columns: [buildCustomCell({
        cellType: 'BusinessUnitDropdown',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectSelector',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectTypeDropdown',
        costFragment
      }), buildCustomCell({
        fieldName: 'rate_type',
        costFragment,
        cellType: 'text',
        disabled: true,
        translateValue: true
      }), '', buildCustomCell({
        fieldName: 'name',
        costFragment,
        cellType: 'text',
        model: 'fragmentable'
      }), buildCustomCell({
        fieldName: 'total',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'capitalised_costs',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'direct_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'indirect_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'consolidated_percentage_of_time_spent',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'eligible_rnd_percentage',
        costFragment,
        cellType: 'percentage',
        disabled: true
      }), buildCustomCell({
        fieldName: 'rnd_amount',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 'pnl_expenditure',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 's1308_claim',
        costFragment,
        cellType: 'number',
        disabled: true
      })]
    }))
  }
};
export const staffingCostFragmentTableSettings = {
  headers,
  buildRows
};